export const appName: string = "contrib";
